import React, { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import nestedData from './nested_website_metadata.json';
import legendImage from './legend.png';

const PathwaySelector = () => {
    const [selectedReference, setSelectedReference] = useState('');
    const [selectedCellType, setSelectedCellType] = useState('');
    const [pathwayOptions, setPathwayOptions] = useState([]);
    const [selectedPathway, setSelectedPathway] = useState('');
    const [imagePath, setImagePath] = useState('');
    const [commonDescriptionHTML, setCommonDescriptionHTML] = useState('');

    const s3BaseUrl = 'https://s3.us-east-2.amazonaws.com/ksusztak.genemap/PM';

    useEffect(() => {
        // Construct the path using PUBLIC_URL
        const descriptionURL = `${process.env.PUBLIC_URL}/commonDescription.html`;
        
        fetch(descriptionURL)
            .then(response => response.text())
            .then(html => setCommonDescriptionHTML(html))
            .catch(error => console.error('Error loading common description:', error));
    }, []);

    const handleReferenceChange = (e) => {
        const reference = e.target.value;
        setSelectedReference(reference);
        setSelectedCellType('');
        setSelectedPathway('');
        setImagePath('');
    };

    const handleCellTypeChange = (e) => {
        const cellType = e.target.value;
        setSelectedCellType(cellType);
        setPathwayOptions(nestedData[selectedReference][cellType] || []);
        setSelectedPathway('');
        setImagePath('');
    };

    const handlePathwaySelect = (event, pathwayName) => {
        setSelectedPathway(pathwayName);
        const pathwayData = pathwayOptions.find((p) => p.Pathway === pathwayName);
        if (pathwayData) {
            setImagePath(`${s3BaseUrl}${pathwayData.Path}`);
        }
    };

    return (
        <div>
            {/* Reference Dropdown */}
            <div style={{ marginBottom: '20px' }}>
                <label>Reference:</label>
                <select value={selectedReference} onChange={handleReferenceChange}>
                    <option value="">Select a Reference</option>
                    {Object.keys(nestedData).map((reference) => (
                        <option key={reference} value={reference}>
                            {reference}
                        </option>
                    ))}
                </select>
            </div>

            {/* Cell Type Dropdown */}
            {selectedReference && (
                <div style={{ marginBottom: '20px' }}>
                    <label>Cell Type:</label>
                    <select value={selectedCellType} onChange={handleCellTypeChange}>
                        <option value="">Select a Cell Type</option>
                        {Object.keys(nestedData[selectedReference]).map((cellType) => (
                            <option key={cellType} value={cellType}>
                                {cellType}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            {/* Pathway Autocomplete - Only show when Reference and Cell Type are selected */}
            {selectedReference && selectedCellType && (
                <div style={{ marginBottom: '20px' }}>
                    <label>Select a Pathway:</label>
                    <Autocomplete
                        options={pathwayOptions.map((option) => option.Pathway)}
                        value={selectedPathway}
                        onChange={handlePathwaySelect}
                        renderInput={(params) => (
                            <TextField {...params} label="Pathway" placeholder="Start typing pathway..." />
                        )}
                        style={{ marginTop: '10px', width: '700px' }}
                    />
                </div>
            )}

            {/* Display Selected Image and Legend */}
            {imagePath && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginTop: '20px' }}>
                    <div>
                        <h3>Selected Pathway Image</h3>
                        <img src={imagePath} alt="Selected Pathway" />
                    </div>
                    <div>
                        <h3>Legend</h3>
                        <img src={legendImage} alt="Legend" />
                    </div>
                </div>
            )}

            {/* Common Description at the Bottom */}
            <div style={{ marginTop: '40px' }} dangerouslySetInnerHTML={{ __html: commonDescriptionHTML }} />
        </div>
    );
};

export default PathwaySelector;

